import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  let formatted_date = formatInTimeZone(date, 'UTC', 'yyyy/MM/dd HH:mm');
  return formatted_date;
};

export default formatDate;
